import React from 'react';
import { useTheme } from 'styled-components';

import { isNotNullish, useMedia } from '@tager/web-core';

import DetailedCarTitleLinks from '@/components/DetailedCarTitleLinks';
import { useTypedSelector } from '@/store/store';
import { selectDetailedCarData } from '@/store/reducers/detailed-car';

function TitleLinks() {
  const isLaptopOnly = useMedia('(max-width: 1539px) and (min-width: 1260px)');
  const data = useTypedSelector(selectDetailedCarData);
  const theme = useTheme();

  if (!data) {
    return null;
  }

  const {
    catalog: { brand, model },
  } = data;

  const linksArray = [
    theme === 'main'
      ? { label: 'Каталог автомобилей', url: '/catalog' }
      : undefined,
    { label: 'Авто в наличии', url: '/cars/new' },
    brand.name && brand.slug
      ? {
          label: brand.name,
          url: `/cars/new/${brand.slug}`,
        }
      : undefined,
    model?.name && brand.slug && model?.slug
      ? {
          label: model.name,
          url: `/cars/new/${brand.slug}/${model.slug}`,
        }
      : undefined,
  ].filter(isNotNullish);

  return <DetailedCarTitleLinks links={linksArray} isMobile={isLaptopOnly} />;
}

export default TitleLinks;
